module.exports = __webpack_public_path__ + "img/gdp.fw.1bef472f.png";